import { createFileRoute } from '@tanstack/react-router';
import { TenderDetailPage } from '@/features/tenders';

/** One tender: its sheet, status, checklist of documents and conversion into a project. */
export const Route = createFileRoute('/_auth/o/$orgId/tenders/$tenderId')({
  component: TenderRoute,
});

function TenderRoute() {
  const { orgId, tenderId } = Route.useParams();
  return <TenderDetailPage orgId={orgId} tenderId={tenderId} />;
}
